import AudioBlockView from 'iovisit-astermantova/components/Blocks/AudioBlock/View';
import AudioBlockEdit from 'iovisit-astermantova/components/Blocks/AudioBlock/Edit';
import audioSVG from '@plone/volto/icons/volume.svg';

export const IoVisitBlocks = (config) => {
  config.blocks.blocksConfig = {
    ...config.blocks.blocksConfig,

    audioBlock: {
      id: 'audioBlock',
      title: 'Audio',
      icon: audioSVG,
      group: 'media',
      view: AudioBlockView,
      edit: AudioBlockEdit,
      mostUsed: false,
      blockHasOwnFocusManagement: false,
      security: {
        addPermission: [],
        view: [],
      },
      sidebarTab: 1,
    },
  };
};
